<!-- eslint-disable no-irregular-whitespace -->
<template>
  <div class="headerMenu text-center">
    <span
      v-if="updateVersionExists && isAdmin"
      class="headerMenu_circle-icon"
    ></span>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      nudge-left="70px"
      bottom
      content-class="headerMenu-menu"
    >
      <template #activator="{ on, attrs }">
        <span v-bind="attrs" class="headerMenu-menu_title" v-on="on">
          <section
            :class="{ 'headerMenu-menu_title--active': menu }"
            class="headerMenu-menu_title"
            x-small
          >
            <span>{{ currentCameraDirectoryName }} / {{ title }}</span>
            <span color="primary" class="icon icon-chevron-down" />
          </section>
        </span>
      </template>
      <v-card>
        <v-list dense>
          <v-list-item dense @click="routerPush({ name: 'home' })">
            <v-list-item-content>
              <v-list-item-title
                :class="{ 'headerMenu-menu_head--active': selectedPage === 0 }"
                v-text="currentCameraDirectoryName"
              >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            dense
            @click="
              menu = false;
              routerPush({ name: 'settings' });
            "
          >
            <v-list-item-icon>
              <app-emoji class="v-icon" value="" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                :class="{ 'headerMenu-menu_head--active': selectedPage === 1 }"
              >
                <span class="headerMenu-menu_settings"
                  >設定

                  <span
                    v-if="updateVersionExists && isAdmin"
                    class="headerMenu_circle-icon"
                  ></span>
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="showHelpMenu"
            dense
            @click="
              menu = false;
              routerPush({ name: 'help' });
            "
          >
            <v-list-item-icon>
              <app-emoji class="v-icon" value="" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                :class="{ 'headerMenu-menu_head--active': selectedPage === 2 }"
                v-text="'お問い合わせ'"
              >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list dense>
          <v-subheader>カメラグループの切り替え</v-subheader>
          <v-list-item-group
            v-model="selectedItem"
            class="headerMenu-menu_org"
            color="primary"
            item-text="text"
            :mandatory="false"
            item-value="val"
            @change="handleSelectCamGroup"
          >
            <v-skeleton-loader
              v-if="loadingCameraGroup"
              v-bind="attrs"
              type="list-item-three-line"
            ></v-skeleton-loader>
            <template v-else>
              <v-list-item v-for="(item, i) in homeGroupItems" :key="i" dense>
                <v-list-item-icon>
                  <check-icon-svg
                    no-circle
                    color="#0075c2"
                    :check-color="
                      +currentHomeGroup === +item.val
                        ? '#0075c2'
                        : 'transparent'
                    "
                    size="24"
                    class="headerMenu-menu_check v-icon"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-menu>
    <!-- Message dialog -->
    <clip-dialog-message
      :open="!!dialogMessageText"
      :message="dialogMessageText"
      @onClose="closeDialogMessage"
    />
    <!-- ----------------- -->
  </div>
</template>
<script>
import { randomInteger } from '@/utils/helpers';
import emojiList from '@/globals/emojiList';
import { mapActions, mapGetters, mapState } from 'vuex';
import CheckIconSvg from './icons/CheckIconSVG.vue';
import { authService } from '@/services/auth.service';
import ClipDialogMessage from '@/components/dialogs/ClipDialogMessage.vue';
import EventBus from '@/utils/eventBus';
import { EventBusEvents } from '@/globals/enums';
import CameraService from '@/services/CameraService';
import { AllCamerasIdGroup } from '@/globals/constants';

export default {
  name: 'HeaderMenu',
  components: { CheckIconSvg, ClipDialogMessage },
  data: () => ({
    menu: false,
    selectedItem: null,
    selectedAvatar: null,
    dialogMessageText: '',
    selectedCamGroup: null,
    savedCameraList: [],
    loadingCameraGroup: false,
  }),
  computed: {
    ...mapGetters('common', {
      updateVersionExists: 'updateVersionExists',
    }),
    ...mapState({
      userAvatars: (state) => state.settings.userAvatars,
      currentAvatarId: (state) => state.settings.currentAvatarId,
      groupCams: (state) => state.settings.groupCams,
      currentHomeGroup: (state) => state.common.currentHomeGroup,
      homeCameraGroups: (state) => state.common.homeCameraGroups,
      currentCameraPolicy: (state) => state.common.currentCameraPolicy,
      isCurrentAvatarOwner: (state) => state.settings.isCurrentAvatarOwner,
      currentCameraDirectoryName: (state) =>
        state.settings.currentCameraDirectoryName,
    }),
    isAdmin() {
      return this.isCurrentAvatarOwner;
    },
    orgItems() {
      return this.userAvatars.map((avatar) => ({
        id: avatar.id,
        text: avatar.name,
        icon: emojiList[randomInteger(0, emojiList.length - 1)],
      }));
    },
    title() {
      return this.homeGroupItems.length &&
        this.homeGroupItems[this.selectedItem]
        ? this.homeGroupItems[this.selectedItem].text
        : '';
    },
    showHelpMenu() {
      return (
        this.isCurrentAvatarOwner ||
        (!this.currentCameraPolicy.access && !this.currentCameraPolicy.liveOnly)
      );
    },
    homeGroupItems() {
      const uniqueByIds = {};
      let groupCams = this.groupCams
        .filter(
          (g) =>
            !!this.homeCameraGroups[g.id] &&
            (this.isAdmin || g.id !== AllCamerasIdGroup)
        )
        .map((group) => ({
          val: group.id,
          text:
            group.id === AllCamerasIdGroup
              ? 'すべてのカメラを表示'
              : group.title,
        }));
      groupCams.forEach((item) => {
        if (!uniqueByIds[item.val]) {
          uniqueByIds[item.val] = item;
        }
      });
      // This parts sort menu to match saved order
      if (this.savedCameraList.length) {
        groupCams = groupCams.sort((a, b) => {
          const indexGroupList = this.savedCameraList.findIndex(
            (item) => item.id === a.val
          );
          const indexSavedList = this.savedCameraList.findIndex(
            (item) => item.id === b.val
          );
          return indexGroupList - indexSavedList;
        });
      }
      let items = [];

      items.push(...Object.values(groupCams));
      return items;
    },
    selectedPage() {
      return this.$route.name.startsWith('help')
        ? 2
        : this.$route.name.startsWith('settings')
        ? 1
        : 0;
    },
  },
  watch: {
    currentAvatarId: {
      handler: function (val) {
        if (val) {
          this.selectedAvatar = val;
          this.savedCameraList =
            CameraService.getCameraListSetting(
              val,
              this.isCurrentAvatarOwner
            ) || [];
        }
      },
      immediate: true,
    },
    homeGroupItems: {
      handler: function (val) {
        if (val) {
          const index = val.findIndex(
            (item) => +item.val === +this.currentHomeGroup
          );
          this.selectedItem = index > -1 ? index : null;
        }
      },
      deep: true,
    },
  },
  created() {
    this.savedCameraList = [];
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('common', ['setCurrentHomeGroup', 'setIsLoading']),
    ...mapActions('settings', ['changeCurrentAvatarId']),
    async init() {
      this.savedCameraList =
        CameraService.getCameraListSetting(
          this.currentAvatarId,
          this.isCurrentAvatarOwner
        ) || [];
    },
    closeDialogMessage() {
      this.dialogMessageText = null;
      let selectedCamGroup = false;
      if (this.selectedCamGroup > -1) {
        selectedCamGroup = this.homeGroupItems[this.selectedCamGroup].val;
        this.setCurrentHomeGroup(selectedCamGroup);
        EventBus.emit(EventBusEvents.CamGroupChanged, {
          group: selectedCamGroup,
        });
        this.selectedCamGroup = null;
      }
    },
    async handleChangeAvatar(avatarId) {
      try {
        this.selectedAvatar = avatarId;
        this.setIsLoading(true);
        this.changeCurrentAvatarId({
          id: this.selectedAvatar,
          updateRecentAvatars: false,
        });
        await authService.scmSignIn(null, this.selectedAvatar);
        this.dialogMessageText = '組織を切り替えました。';
      } catch (error) {
        console.error(error);
      } finally {
        this.setIsLoading(false);
      }
    },
    handleSelectCamGroup(value) {
      this.selectedCamGroup = value;
      this.dialogMessageText = 'カメラグループを切り替えました。';
    },
  },
};
</script>
<style lang="scss">
.headerMenu {
  position: relative;
  &_circle-icon {
    width: 9px;
    height: 9px;
    background-color: #fcc800;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
  }
  &-avatar {
    &--selected {
      &.v-list-item__title {
        color: #0075c2 !important;
        font-weight: bold !important;
      }
    }
  }
  &-menu {
    &_settings {
      position: relative;
      padding-right: 10px;
    }
    &_head {
      &--active {
        font-weight: bold !important;
        color: #666 !important;
      }
    }
    &_org {
      padding-bottom: 8px;
      @include scrollBarCustom;
      &.v-item-group {
        height: 135px;
        overflow-y: auto;
      }
    }
    .v-list-item__icon {
      margin-right: 6px;
      margin-top: 4px;
      margin-bottom: 4px;
      &:first-child {
        margin-right: 6px;
        margin-top: 4px;
        margin-bottom: 4px;
      }
    }
    .v-list-item.v-list-item--dense.theme--light {
      min-height: 32px;
      &.v-list-item--active {
        &::before {
          background-color: #fff;
        }
        .v-list-item__title {
          font-weight: bold;
          color: #0075c2;
        }
      }
      .v-list-item__content {
        padding: 5px 0;
      }
      .v-list-item__title {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #666;
      }
    }
    .theme--light.v-subheader {
      height: 32px;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.75;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
    .v-icon {
      font-size: 16px;
      color: rgb(0 0 0);
    }
    .v-sheet.v-list:not(.v-sheet--outlined) {
      padding: 0;
    }
    .v-sheet.v-card:not(.v-sheet--outlined) {
      width: 300px;
      height: auto;
      padding: 8px 0;
      border-radius: 0;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
      background-color: #fff;
    }
    &_title {
      display: inherit;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.08;
      letter-spacing: normal;
      text-align: right;
      padding: 3px;
      color: rgba(0, 0, 0, 0.6);
      border-radius: 3px;
      &--active {
        background-color: #dbe2f3;
      }
      &_btn {
        .icon {
          margin-left: 8px;
          position: relative;
          display: inline-block;
        }
      }
      .icon {
        margin-left: 5px;
      }
    }
  }
}
</style>
